import { useCallback, useMemo, useState } from 'react';
import { TextField } from '@mui/material';

export default function MultilineCellEdit(props) {
  const { id, field, value, api } = props;
  const [valueState, setValueState] = useState(value);
  const [count, setCount] = useState(value?.length);
  const maxLength = 512;

  const helperText = useMemo(() => {
    let text = `${count}/${maxLength}`;

    if (count === maxLength) {
      text += ' - Max Reached';
    }

    return text;
  }, [valueState]);

  const handleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      setValueState(newValue);
      setCount(newValue.length);
      api.setEditCellValue({ id, field, value: newValue }, event);
    },
    [api, field, id]
  );

  return (
    <TextField
      multiline
      minRows={4}
      autoFocus
      value={valueState}
      helperText={helperText}
      onChange={handleChange}
      onFocus={(e) => handleChange(e, true)}
      onKeyDown={(e) => handleChange(e, true)}
      onKeyUp={(e) => handleChange(e, true)}
      inputProps={{ maxLength: maxLength }}
    />
  );
}
